// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"ed2d20e6","124":"ae647449"}[chunkId] + ".chunk.css";
};